__turbopack_context__.v({
  "preFooterBanner": "PVk28W_preFooterBanner",
  "textContent": "PVk28W_textContent",
});
